import {
  GetEsignatureRequestsDocument,
  GetEsignatureRequestsQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type EsignatureRequest =
  GetEsignatureRequestsQuery['esignature']['requestsConnection']['nodes'][number]
export type Signee = EsignatureRequest['signee']

export const useGetEsignatureRequests = (documentId: string) => {
  const { loading, data } = useQuery(GetEsignatureRequestsDocument, { variables: { documentId } })

  return {
    loadingQL: loading,
    signatureRequests: data?.esignature.requestsConnection.nodes ?? [],
  }
}
